import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './Spinner.styles';
const Spinner = ({ color = 'primary' }) => {
    return (_jsx(S.Container, { children: _jsx(S.Svg, { children: _jsx(S.Circle, { color: color, cx: "50%", cy: "50%", r: "9", fill: "transparent", "fill-opacity": "0" }, void 0) }, void 0) }, void 0));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map